<template>

  <el-dialog
      title=""
      :visible="visible"
      :before-close="close"

      width="560px"
      class="open-session"
      v-if="selectUser"
  >

    <div slot="title">
      <div class="el-dialog__title">Комментрий</div>
      <div class="el-dialog__subtitle">Добавление комментария пользователя</div>
    </div>

    <el-form
        label-position="top"
        ref="sessionOpenForm"
        @keyup.enter.native="save"
        class="open-session__form"
        v-loading="loading"
    >

      <el-input v-model="comment" class="hidden-input"></el-input>

      <el-form-item prop="code" class="session-form">
        <el-input
            ref="textareaComment"
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 8}"
            v-model="comment"
            name="sessionCode"
            auto-complete="off"
            placeholder="Введите комментарий"></el-input>
      </el-form-item>

      <footer-buttons>
        <el-button
            type="primary"
            :loading="loading"
            @click="save"
            name="sendCode">Сохранить
        </el-button>
        <el-button @click="close">Отменить</el-button>

      </footer-buttons>


    </el-form>

  </el-dialog>
</template>

<script>
import FooterButtons from "@/components/dialog/FooterButtons"

export default {
  name: "OpenVisitCommentModal",
  data() {
    return {
      comment: '',
      loading: false,
      current: null,
      currentTime: 30,
      timerCode: null,
      load: false,
      cloneSession: null,
      disabled: false,
      form: null,
      error: null,
    }
  },

  components: {FooterButtons},
  props: {
    selectUser: {
      required: true,
    },
    visible: {
      required: true,
    }
  },
  watch: {
    visible(value) {
      if(value) this.onOpen()
    }
  },
  methods: {
    onOpen() {
      this.comment = ''

      this.getComment()

      this.$nextTick(() => {
        this.$refs.textareaComment.focus()

      })
    },
    close() {
      this.$emit('close')
    },
    getComment() {
      this.loading = true

      this.$api.visit
          .getVisitLightComment(this.selectUser.id)
          .then((response) => {

            this.comment = response.data.comment

          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки комментария 😕",
              message: response.response.data.message,
            })

          })
          .finally(() => {
            this.loading = false
          })
    },
    save() {
      this.loading = true

      this.$api.visit
          .saveVisitLightComment(this.selectUser.id, {comment: this.comment})
          .then(() => {
            this.$notify.success({
              title: "Удачно",
              message: "Комментарий был сохранен",
            })
            this.close()
          })
          .catch((res) => {
            this.$notify.error({
              title: "Ошибка сохранения 😕",
              message: res.response.data.message,
            })
          })
          .finally(() => {
            this.loading = false
          })
    },

  },
}
</script>

<style scoped lang="scss">

.open-session {

  .hidden-input {
    display: none;
  }

}


</style>

